import styled from "styled-components";



export const Container = styled.div`
    /* background-color: red; */
    display: flex;
    justify-content: center;
`

